import { render, staticRenderFns } from "./WorkingGroupForm.vue?vue&type=template&id=6c8594a4"
import script from "./WorkingGroupForm.vue?vue&type=script&lang=js"
export * from "./WorkingGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports